import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    header: {
      marginBottom: theme.spacing(1),
    },
    description: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(19),
      color: COLORS.gray.gray40,
      marginTop: theme.spacing(0.5),
    },
    error: {},
    input: {},
  }),
  { name: 'FieldInput' }
);
